export const setPromotion = (value, limit) => {
    return {
      type: 'SET_PROMOTION',
      payload: { data: value, limit }
    };
  };

  export const setActivePromotion = (value) => {
    return {
      type: 'SET_ACTIVE_PROMOTION',
      payload: { data: value }
    };
  };